import {
  CButton,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
} from "@coreui/react"
import { Flex, Input, Select, Typography, TimePicker } from "antd"
import React, { useState } from "react"
import { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import {
  addAbonementClub,
  editAbonementClub,
  getAbonementTypes,
  getAbonementsListClubs,
  getAbonementsListClubsById,
} from "src/store/Slices/AbonementsSlice"
import { openNotification } from "src/components/helpers/notification"
import dayjs from "dayjs"

const EditNewAbonementCost = ({
  visible,
  setVisible,
  abonementInfo,
  abonementCostInfo,
  payload,
}) => {
  // HELPERS
  const dispatch = useDispatch()

  const [startingTime, setStartingTime] = useState(
    abonementInfo?.startingTime
      ? dayjs(abonementInfo.startingTime, "HH:mm")
      : null,
  )
  const [endingTime, setEndingTime] = useState(
    abonementInfo?.endingTime ? dayjs(abonementInfo.endingTime, "HH:mm") : null,
  )

  const abonementsList = useSelector(
    (state) => state.AbonementsSlice.abonementsList,
  )

  const isDailyOrNightly =
    abonementInfo?.name === "DAILY" || abonementInfo?.name === "NIGHTLY"

  console.log("hasDailyOrNightly", isDailyOrNightly)

  const currentAbonement = abonementsList?.data?.value?.rows?.find(
    (row) => row.id === abonementInfo?.id,
  )

  const optionsFreeze = [
    { label: "Да", value: 1 },
    { label: "Нет", value: 0 },
  ]

  // STORE
  const abonementClubs = useSelector(
    (state) => state.AbonementsSlice.abonementClubs,
  )
  const currentAbonementClub = useSelector(
    (state) => state.AbonementsSlice.abonementCurrentClub,
  )

  // STATE
  const [club, setClub] = useState()
  const [isFreeze, setIsFreeze] = useState()
  const [price, setPrice] = useState()
  const [months, setMonths] = useState()
  const [daysOfFreeze, setDaysOfFreeze] = useState()
  const [name, setName] = useState()
  const [fastbuyButtonName, setFastbuyButtonName] = useState(
    currentAbonementClub?.data?.value?.fastbuyButtonName || "",
  )
  const [suitableFor, setSuitableFor] = useState("")

  useEffect(() => {
    setClub(
      abonementClubs?.data?.value.find(
        (el) => el?.label === abonementCostInfo?.clubName,
      )?.value,
    )
    setIsFreeze(abonementCostInfo?.isFrost === "Да" ? 1 : 0)
    setPrice(abonementCostInfo?.price)
    setMonths(abonementCostInfo?.monthCount)
    setDaysOfFreeze(abonementCostInfo?.frostDays)
    setName(abonementCostInfo?.packetName)
    setFastbuyButtonName(currentAbonementClub?.data?.value?.fastbuyButtonName)
    setSuitableFor(abonementCostInfo?.suitableFor || "")
   
  }, [abonementCostInfo, abonementClubs, currentAbonementClub])

  useEffect(() => {
    dispatch(getAbonementTypes())

    if (abonementCostInfo?.id) {
      dispatch(getAbonementsListClubsById(abonementCostInfo.id))
    }
  }, [abonementCostInfo?.id])

  const onClickAddAbonement = () => {
    dispatch(
      editAbonementClub({
        abonementId: abonementInfo.id,
        id: abonementCostInfo.id,
        clubId: club,
        isFrost: !!isFreeze,
        price: price,
        monthCount: months,
        frostDays: daysOfFreeze,
        packetName: name,
        fastbuyButtonName: fastbuyButtonName,
        suitableFor: suitableFor,
        startingTime: startingTime ? startingTime.format("HH:mm:ss") : null,
        endingTime: endingTime ? endingTime.format("HH:mm:ss") : null,
      }),
    ).then(() => {
      dispatch(
        getAbonementsListClubs({ AbonementId: abonementInfo.id, ...payload }),
      ).then(() => {
        setVisible(false)
      })
      dispatch(getAbonementsListClubsById(abonementInfo.id))
    })
  }

  return (
    <CModal
      alignment='center'
      visible={visible}
      aria-labelledby='VerticallyCenteredExample'
      onClose={() => {
        setVisible(false)
      }}
      keyboard={true}
    >
      <CModalHeader>
        <CModalTitle id='VerticallyCenteredExample'>
          {"Редактировать стоимость пакета"}
        </CModalTitle>
      </CModalHeader>
      <CModalBody
        style={{
          display: "flex",
          justifyContent: "center",
          flexDirection: "column",
        }}
      >
        <Flex vertical gap={16} style={{ marginTop: "20px" }}>
          <>
            <div>
              <Typography.Title level={5}>Клуб</Typography.Title>
              <Select
                style={{ width: "100%" }}
                options={abonementClubs?.data?.value}
                placeholder={"Выбрать"}
                onChange={(value) => {
                  setClub(value)
                }}
                value={club}
              />
            </div>

            <div>
              <Typography.Title level={5}>Разрешена заморозка</Typography.Title>
              <Select
                style={{ width: "100%" }}
                options={optionsFreeze}
                placeholder={"Выбрать"}
                onChange={(value) => {
                  setIsFreeze(value)
                }}
                value={isFreeze}
              />
            </div>

            <div>
              <Typography.Title level={5}>Цена</Typography.Title>
              <Input
                defaultValue=''
                value={price}
                type='number'
                onChange={(e) => setPrice(e.currentTarget.value)}
              />
            </div>

            <div>
              <Typography.Title level={5}>Кол-во месяцев</Typography.Title>
              <Input
                defaultValue=''
                value={months}
                type='number'
                onChange={(e) => setMonths(e.currentTarget.value)}
              />
            </div>

            <div>
              <Typography.Title level={5}>Дней заморозки</Typography.Title>
              <Input
                defaultValue=''
                value={daysOfFreeze}
                type='number'
                onChange={(e) => setDaysOfFreeze(e.currentTarget.value)}
              />
            </div>

            <div>
              <Typography.Title level={5}>Имя пакета</Typography.Title>
              <Input
                defaultValue=''
                value={name}
                onChange={(e) => setName(e.currentTarget.value)}
              />
            </div>

            <div>
              <Typography.Title level={5}>
                Текст для кнопки покупки
              </Typography.Title>
              <Input
                defaultValue=''
                value={fastbuyButtonName}
                onChange={(e) => setFastbuyButtonName(e.currentTarget.value)}
              />
            </div>
            <div>
              <Typography.Title level={5}>Для кого подходит</Typography.Title>
              <Input.TextArea
                rows={4}
                value={suitableFor}
                onChange={(e) => setSuitableFor(e.target.value)}
                placeholder='Опишите, для кого подходит этот пакет'
              />
            </div>

            {isDailyOrNightly && (
              <div>
                <div style={{ marginBottom: "16px" }}>
                  <Typography.Title level={5}>От (время)</Typography.Title>
                  <TimePicker
                    style={{ width: "100%" }}
                    onChange={(time) => setStartingTime(time)}
                    value={startingTime}
                    format='HH:mm'
                    placeholder='Выберите время'
                  />
                </div>

                <div>
                  <Typography.Title level={5}>До (время)</Typography.Title>
                  <TimePicker
                    style={{ width: "100%" }}
                    onChange={(time) => setEndingTime(time)}
                    value={endingTime}
                    format='HH:mm'
                    placeholder='Выберите время'
                  />
                </div>
              </div>
            )}
          </>
        </Flex>
      </CModalBody>
      <CModalFooter>
        <CButton
          onClick={() => {
            setVisible(false)
          }}
          style={{ color: "#fff" }}
          color='secondary'
        >
          Закрыть
        </CButton>
        <CButton onClick={onClickAddAbonement} style={{ color: "#fff" }}>
          Редактировать
        </CButton>
      </CModalFooter>
    </CModal>
  )
}

export default EditNewAbonementCost
